import * as LeadGrid from '../Services/LeadGridCms'
import * as Actions from './CmsActions'

export const initialize = () => async (dispatch) => {
  dispatch({ type: Actions.START_INITIALIZE })

  const [workspaceRes, permission] = await Promise.all([
    LeadGrid.findWorkspace(),
    LeadGrid.findAllPermission(),
  ])

  dispatch({
    type: Actions.LOADED_INITIAL_VALUES,
    payload: {
      postTypes: [],
      taxonomies: [],
      workspace: workspaceRes.data,
      permissions: permission.data,
    },
  })

  dispatch({
    type: Actions.FINISH_INITIALIZE,
  })
}

export const updateCurrentSideMenu = (current) => async (dispatch) => {
  dispatch({
    type: Actions.CHANGE_SIDE_MENU,
    payload: {
      currentMenu: current,
    },
  })
}
